import { createDataGridFilter } from '../create-data-grid-filter';
import {
  createStringFilterModel,
  StringFilterModel,
  stringFilterModelName,
  StringFilterParams,
} from './core';
import { StringFilterComponent } from './string-filter.component';

export const StringFilterDataGrid = createDataGridFilter<
  StringFilterModel,
  StringFilterParams
>((params) => ({
  modelName: stringFilterModelName,
  modelFactory: createStringFilterModel,
  component: (props) => (
    <StringFilterComponent {...props} filterParams={params} />
  ),
}));

export type StringFilterDataGridComponent = ReturnType<
  typeof StringFilterDataGrid
>;
